import { render, staticRenderFns } from "./AskMenuLink.vue?vue&type=template&id=60758d0c&scoped=true&"
import script from "./AskMenuLink.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskMenuLink.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskMenuLink.vue?vue&type=style&index=0&id=60758d0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60758d0c",
  null
  
)

export default component.exports